import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiTarget, FiZap, FiLayout, FiTrendingUp } from 'react-icons/fi';

export default function Overview() {
  const highlights = [
    {
      icon: FiTarget,
      title: 'Precision Skill Paths',
      desc: 'Replaces generic courses with non-linear maps tailored to practical, high-demand technical skills.'
    },
    {
      icon: FiLayout,
      title: 'Micro-Learning Dashboard',
      desc: 'Designed for self-learners who need high-intensity, short-duration sessions that fit into a busy schedule.'
    },
    {
      icon: FiZap,
      title: 'Gamified Retention',
      desc: 'Uses "Daily Boss Encounters" and streaks to transform learning from a chore into a daily quest.'
    },
    {
      icon: FiTrendingUp,
      title: 'Verified Outcomes',
      desc: 'Proof-of-learning through achievement badges and XP metrics that reflect actual synaptic development.'
    }
  ];

  return (
    <div className="space-y-8">
      <div className="bg-navy-900/50 border border-navy-700 p-8 rounded-3xl relative overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-quest-500/5 rounded-full blur-3xl -mr-32 -mt-32" />
        
        <div className="relative z-10 max-w-3xl">
          <h3 className="text-2xl font-bold text-white mb-4">The Future of Vocation Mastery</h3>
          <p className="text-gray-400 leading-relaxed text-lg">
            SkillQuest is a micro-learning challenge ecosystem built for the modern digital pioneer. 
            We solve the "Learning Fatigue" problem by breaking down complex technical domains into 
            interactive, game-inspired nodes. Whether you're mastering React patterns or Neural Design, 
            SkillQuest provides the visual map and the dopamine-driven feedback loop needed to stay consistent.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {highlights.map((item, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.1 }}
            className="p-6 bg-navy-900 border border-navy-800 rounded-2xl hover:border-quest-500/50 transition-colors group"
          >
            <div className="w-12 h-12 rounded-xl bg-navy-800 flex items-center justify-center mb-4 group-hover:shadow-glow-green transition-all">
              <SafeIcon icon={item.icon} className="text-xl text-quest-500" />
            </div>
            <h4 className="font-bold text-white mb-2">{item.title}</h4>
            <p className="text-sm text-gray-500 leading-snug">{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}